import {AfterViewInit, Component, Input} from '@angular/core';
import * as $ from 'jquery';
import * as d3 from 'd3';
import moment from 'moment/moment';
import {CommonService} from '../../../../shared/services/common.service';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-red-light-chart',
  templateUrl: './red-light-chart.component.html',
  styleUrls: ['./red-light-chart.component.css']
})
export class RedLightChartComponent implements AfterViewInit {
  @Input() data: any[];
  colorMap = {

    fiPoints: '#E04F39',
    imputed: 'rgba(224,79,57,0.6)',
    targetNotMet: '#E04F39',
    target: '#3C486B'
  }
  legend = [
    {name: 'Red Line', color: '#F9D949'},
    {name: 'Target', color: '#3C486B'},

  ]
  svg: any;
  margins = {
    top: 10,
    right: 0,
    bottom: 50,
    left: 20,
  };
  width = 100;
  height = 100;

  isWarned = false;
  resizeObserver: ResizeObserver;

  constructor(private commonService: CommonService, private datePipe: DatePipe) {
    // creating resize observer for detecting size change of chart container
    this.resizeObserver = new ResizeObserver(() => {
      this.ngAfterViewInit();
    })
  }


  ngOnChanges() {
    this.ngAfterViewInit();
  }

  ngOnInit() {
    setTimeout(() => {
      const chartContainer = document.getElementById('red-light-chart');
      this.resizeObserver.observe(chartContainer);
    });
  }


  ngAfterViewInit() {
    if (this.data) {
      const container = $('#red-light-chart');
      this.width = container.width();
      this.height = container.height();
      this.createChart();
    }
  }

  createChart() {
    // Kept this warning for the QA and any other user who might face this
    // issue.
    if (!this.isWarned) {
      console.warn(`The chart disappears when the screen is in responsive and the screen size selection is changed from 'Responsive' to any other mobile screen and vice-versa. This is a known issue and needs to be explored. However, this issue does not impact the application or the user experience.`);
    }

    this.isWarned = true;

    d3.select('#red-light-chart svg').remove();

    this.svg = d3.select('#red-light-chart')
      .append('svg')
      .attr('width', '100%')
      .attr('height', '100%')
      .attr('viewBox', `0, -10, ${this.width}, ${this.height + this.margins.bottom - 15}`)
      .attr('preserveAspectRatio', 'xMidYMid meet')
      .append('g')
      .attr('width', '100%')
      .attr('height', '100%')

    // Create the X-axis band scale
    const x = d3.scaleBand()
      .range([0, this.width])
      .domain(this.data?.map(d => this.datePipe.transform(d.date, 'MMMdd')))
      .padding(0.5)

    // Create the Y-axis band scale

    const yMax = d3.max(this.data, (d) => Math.max(d['fiPoints'])) || 0
    const y = d3.scaleLinear()
      .domain([0, yMax])
      .rangeRound([this.height, 0]);

    const yAxis = d3.axisLeft(y);
    this.svg.append('g')
      .call((() => {
          if (yMax === 0) {
            return yAxis.tickValues([])
          } else {
            return yAxis
              .ticks((() => {
                if (yMax < 4) {
                  return yMax;
                }

                return 4;
              })())
              .tickFormat((d) => d3.format(',')(Math.floor(Number(d))))
          }
        })()
      )
    // ********** Create tooltip ********** //
    const tooltip = d3.select('#red-light-chart')
      .append('div')
      .attr('class', 'tooltip')
      .style('position', 'fixed')
      .style('visibility', 'hidden')

    // Create and fill the bars
    const selector = this.svg.selectAll('.bar')
      .data(this.data)
      .enter()

    selector.append('rect')
      .attr('x', (d: any) => x(this.datePipe.transform(d.date, 'MMMdd')))
      .attr('y', (d: any) => y(d.fiPoints))
      .attr('width', x.bandwidth())
      .attr('height', (d: any) => d.fiPoints ? (this.height - y(d.fiPoints)) : 0)
      .attr('fill', (d: any) => {
        if (d.isRlImputed) {
          return this.colorMap.imputed;
        }
        return d.notMeetingTarget ? this.colorMap.fiPoints : this.colorMap.targetNotMet
      })
      .on('mouseover', (event: any, d) => {
        return tooltip
          .html(`
             ${d.isRlImputed ? `Estimated<br>` : ``}
             ${moment(d.date).format('MMM DD, YYYY')}<br>
             ${d.fiPoints} Red Light Servings
          `)
          .transition()
          .duration(200)
          .style('top', (event.clientY - (d.isRlImputed ? this.commonService.convertRemToPx(9) : this.commonService.convertRemToPx(7))) + 'px')
          .style('left', this.commonService.calculateXForPopup(tooltip, event.clientX) + 'px')
          .style('visibility', 'visible');
      })
      .on('mousemove', (event: any, d) => {
        return tooltip
          .transition()
          .duration(0)
          .style('top', (event.clientY - (d.isRlImputed ? this.commonService.convertRemToPx(9) : this.commonService.convertRemToPx(7))) + 'px')
          .style('left', this.commonService.calculateXForPopup(tooltip, event.clientX) + 'px');
      })
      .on('mouseout', (event: any) => {
        return tooltip
          .transition()
          .duration(0)
          .style('visibility', 'hidden');
      });

    // Draw the X-axis on the DOM
    this.svg.append('g')
      .attr('transform', 'translate(0,' + this.height + ')')
      .call(d3.axisBottom(x))
      .selectAll('text')
      .style('text-anchor', 'center')
      .style('font-size', '1.2rem')
      .call(function (t) {
        t.each(function () { // for each one
          const self = d3.select(this);
          const s = self.text().split(' ');  // get the text and split it
          self.text(''); // clear it out
          s.forEach((d, i) => {
            self.append('tspan')
              .attr('x', 0)
              .attr('dy', '1em')
              .text(s[i]);
          })
        })
      })

    //   const svg = d3.select('#red-light-chart').append('svg')
    //       .attr('width', '100%')
    //       .attr('height', '100%')
    //       .attr('viewBox', `-30, 70, 400, 1`)
    //       .attr('preserveAspectRatio', 'xMidYMid meet')
    //     .append('g')
    //     .attr('transform', `translate(${this.margins.left},${this.margins.top})`);
    //
    //   const x = d3.scaleBand()
    //     .range([0, this.width])
    //     .domain(this.data?.map(d => d.date))
    //     .padding(0.5)
    //
    //   const y = d3.scaleLinear()
    //     .domain([0, d3.max(this.data, d => d.fiPoints)])
    //     .nice()
    //     .range([this.height, 0]);
    //
    //   const xAxis = d3.axisBottom(x)
    //     .tickFormat(d => moment(d).format('MMMDD'));
    //
    //   const yAxis = d3.axisLeft(y);
    //
    //   svg.append('g')
    //     .attr('transform', `translate(0,${this.height})`)
    //     .call(xAxis);
    //
    //   svg.append('g')
    //     .call(yAxis);
    //
    //   const barWidth = (this.width / this.data.length) * 0.8;
    //
    //   svg.selectAll('.bar')
    //     .data(this.data)
    //     .enter().append('rect')
    //     .attr('class', 'bar')
    //     .attr('x', d => x(d.date) - barWidth / 2)
    //     .attr('y', d => y(d.fiPoints))
    //     .attr('width', barWidth)
    //     .attr('height', d => this.height - y(d.fiPoints));
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect();
  }
}
